import { render, staticRenderFns } from "./addAndEditAddress.vue?vue&type=template&id=0590c9cf&scoped=true"
import script from "./addAndEditAddress.vue?vue&type=script&lang=js"
export * from "./addAndEditAddress.vue?vue&type=script&lang=js"
import style0 from "./addAndEditAddress.vue?vue&type=style&index=0&id=0590c9cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0590c9cf",
  null
  
)

export default component.exports